import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { LAYER_IDS, QUERY_STATE } from '@tmapy/beetlejuice-utils';
import { useDispatch } from '@tmapy/redux';
import { actionSetLayerFeatures, actionSetExtent, getFeaturesExtent } from '@tmapy/mapcore';
import { InfoAlert, WaitingAlert, DangerAlert } from '@tmapy/style-guide';
import { SearchResultItem } from './SearchResultItem';
export const SearchResults = React.memo(({ tab, isActive, highlightedFeatureIds, queryState, data, getMapPadding }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (data?.features?.length && isActive) {
            data.features.forEach((feature, idx) => {
                if (!feature.id) {
                    feature.id = feature.properties?.id ?? idx;
                }
            });
            dispatch(actionSetLayerFeatures(`${LAYER_IDS.SEARCH}-${tab.id}`, data.features));
            const featuresExtent = getFeaturesExtent(data.features);
            const mapPadding = getMapPadding();
            featuresExtent && dispatch(actionSetExtent(featuresExtent, mapPadding));
        }
        else if (queryState !== QUERY_STATE.WAITING) {
            dispatch(actionSetLayerFeatures(`${LAYER_IDS.SEARCH}-${tab.id}`, []));
        }
        return () => {
            dispatch(actionSetLayerFeatures(`${LAYER_IDS.SEARCH}-${tab.id}`, []));
        };
    }, [dispatch, queryState, data, isActive]);
    return (_jsxs(_Fragment, { children: [queryState === QUERY_STATE.WAITING && _jsx(WaitingAlert, { children: "\u010Cekejte pros\u00EDm..." }), queryState === QUERY_STATE.SUCCESS &&
                (data?.features.length > 0 ? (_jsx("ul", { className: 'sg-a-ml--2 sg-a-mr--2', children: data?.features?.map((feature, idx) => (_jsx(SearchResultItem, { feature: feature, isHighlighted: !!highlightedFeatureIds?.includes(feature.id), zoom: tab.zoom, tabId: tab.id, getMapPadding: getMapPadding }, idx))) })) : (_jsx(InfoAlert, { children: "Zadan\u00E9mu dotazu nevyhovuje \u017E\u00E1dn\u00FD z\u00E1znam" }))), queryState === QUERY_STATE.FAIL && _jsx(DangerAlert, { children: "Vyhled\u00E1v\u00E1n\u00ED selhalo" })] }));
});
//# sourceMappingURL=SearchResults.js.map